import jwtDecode from "jwt-decode";
import { BehaviorSubject } from "rxjs";
import api, { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE } from "../../providers/api";
import { LocalStorage } from "src/framework/commons"
import { UserType } from "./login.types"
import { EmptyResponseException, InvalidException, ParameterRequiredException } from "src/framework/exceptions/Error";
import { appStore, Error } from "../AppStore";
import { UrlUtil } from "src/framework/commons/UrlUtil";
import { notifierStore } from "../../components/commons/dialogs/Notifier/store";
import { authUser$ } from "src/framework/components/navigations/MenuUser";
import { generatePkcePair } from "src/framework/commons/PkceUtil";

export interface ExtraInfoUsuario {
    distribuidor_id?: number | null;
    distribuidor_nome?: string | null;
    distribuidor_cnpj_cpf?: string | null;
    revenda_id?: number | null;
    revenda_nome?: string | null;
    revenda_cnpj_cpf?: string | null;
    isIntelbras?: boolean;
    isRevenda?: boolean; 
    isDistribuidor?: boolean;
    role?: string;
}

export const isLoggedIn$ = new BehaviorSubject<boolean>(false);
export const userInfo$ = new BehaviorSubject<UserType | null>(null);
export const token$ = new BehaviorSubject<string | null>(null);
export const permissoes$ = new BehaviorSubject<string[]>([]);

export const loginFromRedirect = async (token: string): Promise<string> => {
    const origin = window.location.origin.toString()
    const lastChar = origin[origin.length - 1]
    const newOrigin = lastChar === "/" ? origin : `${origin}/`

    const request: IDataRequest = {
        url: "/login/token/external",
        data: {
            logout_redirect_uri: `${newOrigin}signout`
        },
        headers: {
            "Authorization": `Bearer ${token}`
        }
    }

    try {
        const response: IDataResponse = await apiNoLoading.post(request);

        if (response.statusCode === STATUS_CODE.BAD_REQUEST) {
            throw new InvalidException(Array.isArray(response.message) ? response.message[0] : response.message, response.headers);
        }

        if (response.statusCode === STATUS_CODE.INTERNAL_SERVER_ERROR) {
            throw new EmptyResponseException(
                "Erro ao tentar efetuar o login, serviço indisponível"
            );
        }

        if (response.statusCode === STATUS_CODE.OK) {
            const decodedToken: any = jwtDecode(response.data.token);
            LocalStorage.set("solar.token", response.data.token);
            permissoes$.next(await getFuncionalidadesUsuario(response.data.token));
            userInfo$.next(decodedToken.user)
            LocalStorage.set("solar.userInfo", { ...decodedToken.user, ...decodedToken.custom }, true);
            isLoggedIn$.next(true);
            return ""
        }

        return "Erro ao realizar login."
    } catch(error: any) {
        window.history.pushState({}, document.title, window.location.pathname);
        notifierStore.setNotifier({
            title: "Aviso!!!",
            content: error["message"],
            onFinishTimeout: () => {
                notifierStore.setOpen(false)
                if (error.headers?.["conta-post-logout-redirect-url"]) window.location.href = error.headers["conta-post-logout-redirect-url"]
            },
            onClose: async () => {
                notifierStore.setOpen(false)
                if (error.headers?.["conta-post-logout-redirect-url"]) window.location.href = error.headers["conta-post-logout-redirect-url"]
            },
            timeOut: 10000
        })
        notifierStore.setOpen(true)
        return error["message"] || "Erro ao realizar login"
    }
}




export const validateLogin = async (tokenRedirect?: string | null): Promise<string | null> => {
    try {
        const token: string | null = tokenRedirect || LocalStorage.get("solar.token");

        // se encontar o token e ainda for valido faz o login persistido
        if (token) {
            token$.next(token)
            LocalStorage.set("solar.token", token);
            const decodedToken: any = jwtDecode(token);
            userInfo$.next(decodedToken.user)
            isLoggedIn$.next(true)
            LocalStorage.set("solar.userInfo", { ...decodedToken.user, ...decodedToken.custom }, true);

            await getFuncionalidadesUsuario(token);

            /*contaProvider.getDistribuidorRevendaUsuario().then((response) => {
                parseExtraInfo(response)
            });*/

        }
        return token;
    } catch (error) {
        //   localStorage.removeItem("solar.auth");
        //   localStorage.removeItem("solar.userInfo");
        return null;
    }
}

export const getFuncionalidadesUsuario = async (token?: string): Promise<string[]> => {
    try {
      const response = await apiNoLoading.get({
        url: "/funcionalidades/usuario",
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      permissoes$.next(response.data || []);

      return response.data || []
    } catch (error) {
      return [];
    }
  }

export const doLogin = async ({ username, password }: { username: string, password: string }): Promise<boolean> => {
    try {

        if (password === "" || username === "") {
            throw new ParameterRequiredException(
                "Usuário ou senha estão em branco"
            );
        }
        // efetua o login na pla
        const response: IDataResponse = await api.post({
            url: "/login",
            data: { username: username, password: password },
            headers: {
                Accpet: "*/*",
            },
        });

        if (response.statusCode === STATUS_CODE.BAD_REQUEST) {
            throw new InvalidException(response.message || "Credenciais inválidas");
        }

        if (response.statusCode !== STATUS_CODE.OK) {
            if (response.statusCode === STATUS_CODE.INTERNAL_SERVER_ERROR) {
                throw new EmptyResponseException(
                    "Erro ao tentar efetuar o login, serviço indisponível"
                );
            }
        }

        if (Object.keys(response.data).indexOf("token") < 0) {
            throw new EmptyResponseException(
                "Erro ao tentar efetuar o login, sem resposta do serviço"
            );
        }
        // decode jwt
        const decodedToken: any = jwtDecode(response.data.token);
        token$.next(response.data.token)
        LocalStorage.set("solar.token", response.data.token);

        userInfo$.next(decodedToken.user)
        LocalStorage.set("solar.token", response.data.token);
        LocalStorage.set("solar.userInfo", { ...decodedToken.user, ...decodedToken.custom }, true);

        await getFuncionalidadesUsuario();

        // isLoggedIn$.next(true);

        /*contaProvider.getDistribuidorRevendaUsuario().then((response) => {
            if (response) {
                parseExtraInfo(response)
            }
        });*/

        return true;
    } catch (error: any) {
        let _error: Error = {
            error: "",
            code: error.code,
            message: error["message"],
        };

        notifierStore.setNotifier({
            content: _error.message,
            title: "Aviso",
            timeOut: 2500,
            onClose: () => notifierStore.setOpen(false),
        });
        notifierStore.setOpen(true);
        appStore.setError(_error.message);
        return false;
    }
}

export const getContaUrlCompleto = async (redirectUri: string): Promise<string> => {
    try {
        let redirectUriLocal = redirectUri.includes("signout") ? window.location.origin : redirectUri
        redirectUriLocal = redirectUriLocal.endsWith("/") ? redirectUriLocal : `${redirectUriLocal}/`

        const { codeChallenge, codeVerifier } = await generatePkcePair()
        if (!codeChallenge) {
            throw new InvalidException("Erro ao gerar code challenge")
        }

        LocalStorage.set('solar.code_verifier', codeVerifier)
        const contaUrl = await getUrlContaUnica(redirectUriLocal, codeChallenge)

        if (!contaUrl) {
            throw new InvalidException("Erro ao gerar conta url")
        }

        
        return contaUrl
    } catch (error: any) {
        return ""
    }
}

export const getUrlContaUnica = async (uri: string, codeChallenge: string): Promise<string> => {
    try {
        const baseUrl = `${process.env.REACT_APP_API_BASE_URL}`
        const _url = UrlUtil.generateUrl({ baseUrl: baseUrl, path: "/login/conta", searchParameters: { uri, code_challenge: codeChallenge } })
        const request: IDataRequest = {
            url: _url.relative,
        }

        const response: IDataResponse = await apiNoLoading.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            return response.data.redirect
        }
        return "";
    } catch (e) {
        return ""
    }
}


export const doLoginContaUnica = async (guid: string, session: string, fullPath: string, codeVerifier: string): Promise<string> => {
    try {
        if (guid === "" || fullPath === "") {
            // gerar error
            return "Erro ao realizar login"
        }

        const data = {
            code: guid,
            uri: fullPath,
            session_state: session,
            code_verifier: codeVerifier,
            logout_redirect_uri: `${window.location.origin}/signout`
        }

        const request: IDataRequest = {
            url: "/login/conta",
            data: data,
        }

        const response: IDataResponse = await api.post(request);

        if (response.statusCode === STATUS_CODE.BAD_REQUEST) {
            throw new InvalidException(Array.isArray(response.message) ? response.message[0] : response.message, response.headers);
        }

        if (response.statusCode !== STATUS_CODE.OK) {
            if (response.statusCode === STATUS_CODE.INTERNAL_SERVER_ERROR) {
                throw new EmptyResponseException(
                    "Erro ao tentar efetuar o login, serviço indisponível"
                );
            }
        }

        if (response.statusCode === STATUS_CODE.OK) {

            const decodedToken: any = jwtDecode(response.data.token);
            token$.next(response.data.token)
            LocalStorage.set("solar.token", response.data.token);

            userInfo$.next(decodedToken.user)

            LocalStorage.set("solar.token", response.data.token);
            LocalStorage.set("solar.userInfo", { ...decodedToken.user, ...decodedToken.custom }, true);

            isLoggedIn$.next(true);
            return ""
        }
        return "Erro ao realizar login"
    } catch (error: any) {
        window.history.pushState({}, document.title, window.location.pathname);
        notifierStore.setNotifier({
            title: "Aviso!!!",
            content: error["message"],
            onFinishTimeout: () => {
                notifierStore.setOpen(false)
                if (error.headers?.["conta-post-logout-redirect-url"]) window.location.href = error.headers["conta-post-logout-redirect-url"]
            },
            onClose: async () => {
                notifierStore.setOpen(false)
                if (error.headers?.["conta-post-logout-redirect-url"]) window.location.href = error.headers["conta-post-logout-redirect-url"]
            },
            timeOut: 10000
        })
        notifierStore.setOpen(true)
        return error["message"] || "Erro ao realizar login"
    }
}

export const doLogOutContaUnica = async (): Promise<string | null | undefined> => {
    let redirectURL: string | null | undefined = null
    try {
      const origin = window.location.origin.toString()
      const lastChar = origin[origin.length - 1]
      const newOrigin = lastChar === "/" ? origin : `${origin}/`

      const request: IDataRequest = {
          url: "/logout/conta",
          data: {
              redirect_uri: `${newOrigin}signout`
          }
      }

      const responseConta = await api.post(request);

      if (responseConta.statusCode !== STATUS_CODE.OK) {
          throw new InvalidException(responseConta.message)
      }

      redirectURL = responseConta?.data?.redirect_uri
    } catch (error) {
        const messages: string[] = error instanceof InvalidException ? [error.message] : [error as string]

        notifierStore.setNotifier({
            title: "Aviso!!!",
            content: messages,
            onClose: () => notifierStore.setOpen(false),
            timeOut: 2500
        })

        notifierStore.setOpen(true)
    }

    return redirectURL;
}

export const doLogOut = async (): Promise<void> => {
    try {
        // const request: IDataRequest = {
        //     url: "/logout/conta",
        //     data: {
        //         redirect_uri: `${window.location.origin}/`
        //     }
        // }

        // const responseConta = await api.post(request);

        // if (responseConta.statusCode !== STATUS_CODE.OK) {
        //     throw new InvalidException(responseConta.message)
        // }
        // redirectURL = responseConta?.data?.redirect_uri
   

        permissoes$.next([]);

    } catch (error) {

        const messages: string[] = error instanceof InvalidException ? [error.message] : [error as string]

        notifierStore.setNotifier({
            title: "Aviso!!!",
            content: messages,
            onClose: () => notifierStore.setOpen(false),
            timeOut: 2500
        })

        notifierStore.setOpen(true)
    }
}

export const getUserExtraData = async () => {
    if (userInfo$.getValue()?.userId) {
        /*contaProvider.getDistribuidorRevendaUsuario().then((response) => {
            parseExtraInfo(response)
        });*/

        const token = LocalStorage.get("solar.token")
            if (token) {

                const decodedToken: any = jwtDecode(token)

                const fields = Object.keys(decodedToken as any);

                const userExtraInfo: ExtraInfoUsuario = {
                    isIntelbras: false,
                    isDistribuidor: false,
                    isRevenda: false,
                };

                if (fields.includes('custom')) {
                    if (decodedToken?.custom?.revenda?.id !== null && decodedToken?.custom?.distribuidor?.id !== null) {
                        userExtraInfo.revenda_id = decodedToken?.custom?.revenda?.id;
                        userExtraInfo.revenda_nome = decodedToken?.custom?.revenda?.nome;
                        userExtraInfo.revenda_cnpj_cpf = decodedToken?.custom?.revenda?.cnpj_cpf;
                        userExtraInfo.distribuidor_id = decodedToken?.custom?.distribuidor?.id;
                        userExtraInfo.distribuidor_nome = decodedToken?.custom?.distribuidor?.nome;
                        userExtraInfo.distribuidor_cnpj_cpf = decodedToken?.custom?.distribuidor?.cnpj_cpf;
                        userExtraInfo.isRevenda = true
                        userExtraInfo.isDistribuidor = false
                        userExtraInfo.isIntelbras = false
                    }

                    if (decodedToken?.custom?.distribuidor?.id && decodedToken?.custom?.revenda?.id === null) {
                        userExtraInfo.revenda_id = null;
                        userExtraInfo.revenda_nome = null;
                        userExtraInfo.revenda_cnpj_cpf = null;
                        userExtraInfo.distribuidor_id = decodedToken?.custom?.distribuidor?.id;
                        userExtraInfo.distribuidor_nome = decodedToken?.custom?.distribuidor?.nome;
                        userExtraInfo.distribuidor_cnpj_cpf = decodedToken?.custom?.distribuidor?.cnpj_cpf;
                        userExtraInfo.isRevenda = false
                        userExtraInfo.isDistribuidor = true
                        userExtraInfo.isIntelbras = false
                    }

                } else {
                    userExtraInfo.revenda_id = null;
                    userExtraInfo.revenda_nome = null;
                    userExtraInfo.revenda_cnpj_cpf = null;
                    userExtraInfo.distribuidor_id = null;
                    userExtraInfo.distribuidor_nome = null;
                    userExtraInfo.distribuidor_cnpj_cpf = null;
                    userExtraInfo.isIntelbras = true
                    userExtraInfo.isRevenda = false
                    userExtraInfo.isDistribuidor = false
                }
                if (isLoggedIn$.getValue()) {
                    const informacoes = await getUserInfo();
                    if (informacoes.statusCode === STATUS_CODE.OK) {
                        if (informacoes?.data?.[0]) {
                            userExtraInfo.role = informacoes?.data?.[0]?.role || "Não definido";
                        }
                    }
                    authUser$.next(userExtraInfo);
                }
                parseExtraInfo(userExtraInfo)
            }
    }
}

export const parseExtraInfo = (response: any) => {
    if (response) {
        const userInfo: any = {
            ...userInfo$.getValue(),
            ...response,
            isIntelbras: response.distribuidor_id === null && response.revenda_id === null,
            isDistribuidor: response.distribuidor_id !== null && response.revenda_id === null,
            isRevenda: response.distribuidor_id !== null && response.revenda_id !== null,
        }
        LocalStorage.set("solar.userExtraInfo", userInfo, true);
    }
} 

export const getUserInfo = async (): Promise<IDataResponse> => {
    try {
        const response: IDataResponse = await apiNoLoading.get({
            url: `/usuario/informacoes`,
        });

        return response;   
    
    } catch (error: any) {
        return {
            data: [],
            message: error.message,
            statusCode: 400
        }
    }
}